"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const moment = require("moment");
const Formatter_1 = __importDefault(require("../../Formatter"));
class ThreeWTag {
    constructor(item) {
        this.id = null;
        this.what = '';
        this.who = '';
        this.when = '';
        this.done = false;
        for (let key in item) {
            if (this.hasOwnProperty(key)) {
                this[key] = item[key];
            }
        }
    }
    get Date() {
        return moment(this.when, Formatter_1.default.serverDateFormat);
    }
}
module.exports = ThreeWTag;
